@if (workCenterUtilisation) {
  <div class="layout-col gap-sm">
    <div class="layout-row">
      <elder-progress-bar
        class="flex"
        [bars]="calculateUtilisation(workCenterUtilisation)"
        [minHeight]="barThickness"
      >
      </elder-progress-bar>
    </div>
    @if (showLegend) {
      <div class="flex layout-row place-between-center">
        <div class="layout-row place-start-center gap-sm">
          <div style="height: 12px; width: 12px" [style.background-color]="Colors.completed"></div>
          <span class="text-body-medium"
            >{{ 'manufacturing.scheduling.completed' | translate }} :
            {{ getCompletedWeight(workCenterUtilisation) | elderQuantity }}
          </span>
        </div>
        <div class="layout-row place-start-center gap-sm">
          <div style="height: 12px; width: 12px" [style.background-color]="Colors.progress"></div>
          <span class="text-body-medium"
            >{{ 'manufacturing.scheduling.progress' | translate }} :
            {{ getInProgressWeight(workCenterUtilisation) | elderQuantity }}
          </span>
        </div>
        <div class="layout-row place-start-center gap-sm">
          <div
            style="height: 12px; width: 12px"
            [style.background-color]="Colors.readyForProduction"
          ></div>
          <span class="text-body-medium"
            >{{ 'manufacturing.scheduling.readyForProduction' | translate }} :
            {{ getReadyWeight(workCenterUtilisation) | elderQuantity }}
          </span>
        </div>
        <div class="layout-row place-start-center gap-sm">
          <div style="height: 12px; width: 12px" [style.background-color]="Colors.onHold"></div>
          <span class="text-body-medium"
            >{{ 'manufacturing.scheduling.onHold' | translate }} :
            {{ getOnHoldWeight(workCenterUtilisation) | elderQuantity }}
          </span>
        </div>
      </div>
    }
  </div>
}
